// // import {
// //   Modal,
// //   ModalOverlay,
// //   ModalContent,
// //   ModalHeader,
// //   ModalBody,
// //   ModalFooter,
// //   Button,
// //   FormControl,
// //   FormLabel,
// //   Input,
// //   Select,
// //   Textarea,
// //   VStack,
// //   useToast
// // } from "@chakra-ui/react";

// // import { useEffect, useState } from "react";

// // import PacienteAutocomplete from "../../components/common/PacienteAutocomplete";
// // import { ProfissionalService } from "../../services/profissional.service";
// // import { ProcedimentoService } from "../../services/procedimento.service";

// // interface Props {
// //   isOpen: boolean;
// //   onClose: () => void;
// //   onSave: (data: any) => void;
// //   initialData?: any;
// // }

// // function toDatetimeLocal(value?: string) {
// //   if (!value) return "";

// //   const normalized = String(value).trim().replace(" ", "T");

// //   if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) {
// //     return normalized;
// //   }

// //   if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(normalized)) {
// //     return normalized.slice(0, 16);
// //   }

// //   return normalized;
// // }

// // export default function FormModal({
// //   isOpen,
// //   onClose,
// //   onSave,
// //   initialData
// // }: Props) {

// //   const toast = useToast();

// //   const [profissionais, setProfissionais] = useState<any[]>([]);
// //   const [procedimentos, setProcedimentos] = useState<any[]>([]);

// //   const [form, setForm] = useState<any>({
// //     ficha_id: "",
// //     paciente_label: "",
// //     profissional_id: "",
// //     procedimento_id: "",
// //     data_agendamento: "",
// //     observacao: ""
// //   });

// //   useEffect(() => {
// //     if (!isOpen) return;

// //     async function loadCombos() {
// //       const [p, pr] = await Promise.all([
// //         ProfissionalService.findAll(),
// //         ProcedimentoService.findAll()
// //       ]);

// //       setProfissionais(Array.isArray(p) ? p : []);
// //       setProcedimentos(Array.isArray(pr) ? pr : []);
// //     }

// //     loadCombos();
// //   }, [isOpen]);

// //   useEffect(() => {
// //     if (initialData) {
// //       setForm({
// //         ficha_id: String(initialData.ficha_id ?? ""),
// //         paciente_label: initialData.paciente_nome
// //           ? `${initialData.paciente_nome}${initialData.paciente_cpf ? ` - ${initialData.paciente_cpf}` : ""}`
// //           : "",
// //         profissional_id: String(initialData.profissional_id ?? ""),
// //         procedimento_id: String(initialData.procedimento_id ?? ""),
// //         data_agendamento: toDatetimeLocal(initialData.data_agendamento),
// //         observacao: initialData.observacao ?? ""
// //       });
// //       return;
// //     }

// //     setForm({
// //       ficha_id: "",
// //       paciente_label: "",
// //       profissional_id: "",
// //       procedimento_id: "",
// //       data_agendamento: "",
// //       observacao: ""
// //     });
// //   }, [initialData, isOpen]);

// //   function handleSave() {
// //     if (!form.ficha_id) {
// //       toast({ title: "Selecione o paciente", status: "error" });
// //       return;
// //     }

// //     if (!form.profissional_id) {
// //       toast({ title: "Selecione o profissional", status: "error" });
// //       return;
// //     }

// //     if (!form.procedimento_id) {
// //       toast({ title: "Selecione o procedimento", status: "error" });
// //       return;
// //     }

// //     if (!form.data_agendamento) {
// //       toast({ title: "Informe a data do agendamento", status: "error" });
// //       return;
// //     }

// //     onSave({
// //       ficha_id: Number(form.ficha_id),
// //       profissional_id: Number(form.profissional_id),
// //       procedimento_id: Number(form.procedimento_id),
// //       data_agendamento: form.data_agendamento,
// //       observacao: form.observacao
// //     });
// //   }

// //   return (
// //     <Modal isOpen={isOpen} onClose={onClose} size="2xl">
// //       <ModalOverlay />

// //       <ModalContent>
// //         <ModalHeader>
// //           {initialData ? "Editar Agendamento" : "Novo Agendamento"}
// //         </ModalHeader>

// //         <ModalBody>
// //           <VStack spacing={4} align="stretch">
// //             <FormControl>
// //               <FormLabel>Paciente</FormLabel>
// //               <PacienteAutocomplete
// //                 valueId={form.ficha_id ? Number(form.ficha_id) : null}
// //                 valueLabel={form.paciente_label}
// //                 onSelect={(item) => {
// //                   if (!item) {
// //                     setForm((old: any) => ({
// //                       ...old,
// //                       ficha_id: "",
// //                       paciente_label: ""
// //                     }));
// //                     return;
// //                   }

// //                   setForm((old: any) => ({
// //                     ...old,
// //                     ficha_id: String(item.id),
// //                     paciente_label: `${item.nome || ""}${item.cpf ? ` - ${item.cpf}` : ""}`.trim()
// //                   }));
// //                 }}
// //               />
// //             </FormControl>

// //             <FormControl>
// //               <FormLabel>Profissional</FormLabel>
// //               <Select
// //                 value={form.profissional_id}
// //                 onChange={(e) => setForm({ ...form, profissional_id: e.target.value })}
// //               >
// //                 <option value="">Selecione...</option>
// //                 {profissionais.map((item) => (
// //                   <option key={item.id} value={item.id}>
// //                     {item.nome} - {item.profissao}
// //                   </option>
// //                 ))}
// //               </Select>
// //             </FormControl>

// //             <FormControl>
// //               <FormLabel>Procedimento</FormLabel>
// //               <Select
// //                 value={form.procedimento_id}
// //                 onChange={(e) => setForm({ ...form, procedimento_id: e.target.value })}
// //               >
// //                 <option value="">Selecione...</option>
// //                 {procedimentos.map((item) => (
// //                   <option key={item.id} value={item.id}>
// //                     {item.procedimento}
// //                   </option>
// //                 ))}
// //               </Select>
// //             </FormControl>

// //             <FormControl>
// //               <FormLabel>Data do agendamento</FormLabel>
// //               <Input
// //                 type="datetime-local"
// //                 value={form.data_agendamento}
// //                 onChange={(e) => setForm({ ...form, data_agendamento: e.target.value })}
// //               />
// //             </FormControl>

// //             <FormControl>
// //               <FormLabel>Observação (opcional)</FormLabel>
// //               <Textarea
// //                 value={form.observacao}
// //                 onChange={(e) => setForm({ ...form, observacao: e.target.value })}
// //               />
// //             </FormControl>
// //           </VStack>
// //         </ModalBody>

// //         <ModalFooter>
// //           <Button mr={3} onClick={onClose}>
// //             Cancelar
// //           </Button>

// //           <Button colorScheme="blue" onClick={handleSave}>
// //             Salvar
// //           </Button>
// //         </ModalFooter>
// //       </ModalContent>
// //     </Modal>
// //   );
// // }



// import {
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Button,
//   FormControl,
//   FormLabel,
//   Input,
//   Select,
//   Textarea,
//   VStack,
//   HStack,
//   Box,
//   Text,
//   Divider,
//   Flex,
//   Icon,
//   useToast
// } from "@chakra-ui/react";

// import { useEffect, useState } from "react";
// import { FiCalendar, FiClock, FiUser, FiFileText, FiX } from "react-icons/fi";

// import PacienteAutocomplete from "../../components/common/PacienteAutocomplete";
// import { ProfissionalService } from "../../services/profissional.service";
// import { ProcedimentoService } from "../../services/procedimento.service";

// interface Props {
//   isOpen: boolean;
//   onClose: () => void;
//   onSave: (data: any) => void;
//   initialData?: any;
// }

// function toDatetimeLocal(value?: string) {
//   if (!value) return "";

//   const normalized = String(value).trim().replace(" ", "T");

//   if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) {
//     return normalized;
//   }

//   if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(normalized)) {
//     return normalized.slice(0, 16);
//   }

//   return normalized;
// }

// export default function FormModal({
//   isOpen,
//   onClose,
//   onSave,
//   initialData
// }: Props) {
//   const toast = useToast();

//   const [profissionais, setProfissionais] = useState<any[]>([]);
//   const [procedimentos, setProcedimentos] = useState<any[]>([]);

//   const [form, setForm] = useState<any>({
//     ficha_id: "",
//     paciente_label: "",
//     profissional_id: "",
//     procedimento_id: "",
//     data_agendamento: "",
//     observacao: ""
//   });

//   useEffect(() => {
//     if (!isOpen) return;

//     async function loadCombos() {
//       const [p, pr] = await Promise.all([
//         ProfissionalService.findAll(),
//         ProcedimentoService.findAll()
//       ]);

//       setProfissionais(Array.isArray(p) ? p : []);
//       setProcedimentos(Array.isArray(pr) ? pr : []);
//     }

//     loadCombos();
//   }, [isOpen]);

//   useEffect(() => {
//     if (initialData) {
//       setForm({
//         ficha_id: String(initialData.ficha_id ?? ""),
//         paciente_label: initialData.paciente_nome
//           ? `${initialData.paciente_nome}${initialData.paciente_cpf ? ` - ${initialData.paciente_cpf}` : ""}`
//           : "",
//         profissional_id: String(initialData.profissional_id ?? ""),
//         procedimento_id: String(initialData.procedimento_id ?? ""),
//         data_agendamento: toDatetimeLocal(initialData.data_agendamento),
//         observacao: initialData.observacao ?? ""
//       });
//       return;
//     }

//     setForm({
//       ficha_id: "",
//       paciente_label: "",
//       profissional_id: "",
//       procedimento_id: "",
//       data_agendamento: "",
//       observacao: ""
//     });
//   }, [initialData, isOpen]);

//   function handleSave() {
//     if (!form.ficha_id) {
//       toast({
//         title: "Selecione o paciente",
//         status: "error",
//         position: "top-right",
//         duration: 3000
//       });
//       return;
//     }

//     if (!form.profissional_id) {
//       toast({
//         title: "Selecione o profissional",
//         status: "error",
//         position: "top-right",
//         duration: 3000
//       });
//       return;
//     }

//     if (!form.procedimento_id) {
//       toast({
//         title: "Selecione o procedimento",
//         status: "error",
//         position: "top-right",
//         duration: 3000
//       });
//       return;
//     }

//     if (!form.data_agendamento) {
//       toast({
//         title: "Informe a data do agendamento",
//         status: "error",
//         position: "top-right",
//         duration: 3000
//       });
//       return;
//     }

//     onSave({
//       ficha_id: Number(form.ficha_id),
//       profissional_id: Number(form.profissional_id),
//       procedimento_id: Number(form.procedimento_id),
//       data_agendamento: form.data_agendamento,
//       observacao: form.observacao
//     });
//   }

//   const inputStyles = {
//     size: "md" as const,
//     borderColor: "gray.200",
//     borderRadius: "md",
//     bg: "white",
//     fontSize: "sm",
//     transition: "all 0.2s",
//     _hover: {
//       borderColor: "gray.300"
//     },
//     _focus: {
//       borderColor: "blue.400",
//       boxShadow: "0 0 0 1px var(--chakra-colors-blue-400)"
//     }
//   };

//   const labelStyles = {
//     fontSize: "sm",
//     fontWeight: "600",
//     color: "gray.700",
//     mb: 2
//   };

//   return (
//     <Modal
//       isOpen={isOpen}
//       onClose={onClose}
//       size="2xl"
//       isCentered
//       scrollBehavior="inside"
//     >
//       <ModalOverlay bg="blackAlpha.500" backdropFilter="blur(2px)" />

//       <ModalContent
//         borderRadius="xl"
//         overflow="hidden"
//         mx={3}
//         boxShadow="0 12px 40px rgba(0, 0, 0, 0.16)"
//       >
//         {/* Cabeçalho */}
//         <ModalHeader px={6} py={4} borderBottom="1px solid" borderColor="gray.100">
//           <Flex align="center" justify="space-between" gap={3}>
//             <HStack spacing={3}>
//               <Flex
//                 align="center"
//                 justify="center"
//                 boxSize="42px"
//                 borderRadius="lg"
//                 bg="blue.50"
//                 color="blue.600"
//                 flexShrink={0}
//               >
//                 <Icon as={FiCalendar} boxSize={5} />
//               </Flex>

//               <Box>
//                 <Text fontSize="lg" fontWeight="700" color="gray.800" lineHeight="1.4">
//                   {initialData ? "Editar agendamento" : "Agendar novo atendimento"}
//                 </Text>
//                 <Text fontSize="xs" fontWeight="normal" color="gray.500" mt={1}>
//                   Preencha os dados para {initialData ? "atualizar o" : "realizar o"} agendamento
//                 </Text>
//               </Box>
//             </HStack>

//             <Button
//               variant="ghost"
//               size="sm"
//               minW="32px"
//               h="32px"
//               px={0}
//               color="gray.500"
//               aria-label="Fechar modal"
//               onClick={onClose}
//               _hover={{ bg: "gray.100", color: "gray.700" }}
//             >
//               <Icon as={FiX} boxSize={5} />
//             </Button>
//           </Flex>
//         </ModalHeader>

//         <ModalBody px={{ base: 4, md: 6 }} py={5} bg="gray.50">
//           <VStack align="stretch" spacing={5}>
//             {/* Seção: Paciente */}
//             <Box
//               bg="white"
//               border="1px solid"
//               borderColor="gray.200"
//               borderRadius="lg"
//               p={{ base: 3, md: 4 }}
//             >
//               <HStack spacing={2} mb={4}>
//                 <Icon as={FiUser} color="blue.500" boxSize={4} />
//                 <Text fontSize="sm" fontWeight="700" color="gray.700">
//                   Dados do paciente
//                 </Text>
//               </HStack>

//               <FormControl isRequired>
//                 <FormLabel {...labelStyles}>Paciente</FormLabel>

//                 <PacienteAutocomplete
//                   valueId={form.ficha_id ? Number(form.ficha_id) : null}
//                   valueLabel={form.paciente_label}
//                   onSelect={(item) => {
//                     if (!item) {
//                       setForm((old: any) => ({
//                         ...old,
//                         ficha_id: "",
//                         paciente_label: ""
//                       }));
//                       return;
//                     }

//                     setForm((old: any) => ({
//                       ...old,
//                       ficha_id: String(item.id),
//                       paciente_label: `${item.nome || ""}${item.cpf ? ` - ${item.cpf}` : ""}`.trim()
//                     }));
//                   }}
//                 />

//                 <Text fontSize="xs" color="gray.500" mt={2}>
//                   Pesquise pelo nome ou CPF para localizar o paciente.
//                 </Text>
//               </FormControl>
//             </Box>

//             {/* Seção: Atendimento */}
//             <Box
//               bg="white"
//               border="1px solid"
//               borderColor="gray.200"
//               borderRadius="lg"
//               p={{ base: 3, md: 4 }}
//             >
//               <HStack spacing={2} mb={4}>
//                 <Icon as={FiFileText} color="blue.500" boxSize={4} />
//                 <Text fontSize="sm" fontWeight="700" color="gray.700">
//                   Dados do atendimento
//                 </Text>
//               </HStack>

//               <VStack align="stretch" spacing={4}>
//                 <FormControl isRequired>
//                   <FormLabel {...labelStyles}>Profissional</FormLabel>

//                   <Select
//                     {...inputStyles}
//                     placeholder="Selecione o profissional"
//                     value={form.profissional_id}
//                     onChange={(e) =>
//                       setForm({ ...form, profissional_id: e.target.value })
//                     }
//                   >
//                     {profissionais.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.nome} - {item.profissao}
//                       </option>
//                     ))}
//                   </Select>
//                 </FormControl>

//                 <FormControl isRequired>
//                   <FormLabel {...labelStyles}>Procedimento</FormLabel>

//                   <Select
//                     {...inputStyles}
//                     placeholder="Selecione o procedimento"
//                     value={form.procedimento_id}
//                     onChange={(e) =>
//                       setForm({ ...form, procedimento_id: e.target.value })
//                     }
//                   >
//                     {procedimentos.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.procedimento}
//                       </option>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </VStack>
//             </Box>

//             {/* Seção: Data e horário */}
//             <Box
//               bg="white"
//               border="1px solid"
//               borderColor="gray.200"
//               borderRadius="lg"
//               p={{ base: 3, md: 4 }}
//             >
//               <HStack spacing={2} mb={4}>
//                 <Icon as={FiClock} color="blue.500" boxSize={4} />
//                 <Text fontSize="sm" fontWeight="700" color="gray.700">
//                   Data e horário
//                 </Text>
//               </HStack>

//               <Flex
//                 direction={{ base: "column", md: "row" }}
//                 gap={4}
//               >
//                 <FormControl isRequired flex="1">
//                   <FormLabel {...labelStyles}>Data e hora do agendamento</FormLabel>

//                   <Input
//                     {...inputStyles}
//                     type="datetime-local"
//                     value={form.data_agendamento}
//                     onChange={(e) =>
//                       setForm({ ...form, data_agendamento: e.target.value })
//                     }
//                   />
//                 </FormControl>
//               </Flex>
//             </Box>

//             {/* Seção: Observações */}
//             <Box
//               bg="white"
//               border="1px solid"
//               borderColor="gray.200"
//               borderRadius="lg"
//               p={{ base: 3, md: 4 }}
//             >
//               <FormControl>
//                 <FormLabel {...labelStyles}>Observações</FormLabel>

//                 <Textarea
//                   {...inputStyles}
//                   value={form.observacao}
//                   onChange={(e) =>
//                     setForm({ ...form, observacao: e.target.value })
//                   }
//                   placeholder="Adicione informações relevantes sobre o atendimento (opcional)"
//                   resize="vertical"
//                   minH="90px"
//                 />

//                 <Text fontSize="xs" color="gray.500" mt={2}>
//                   Campo opcional.
//                 </Text>
//               </FormControl>
//             </Box>
//           </VStack>
//         </ModalBody>

//         <Divider borderColor="gray.100" />

//         {/* Rodapé */}
//         <ModalFooter
//           px={6}
//           py={4}
//           bg="white"
//           justifyContent="space-between"
//           gap={3}
//         >
//           <Button
//             variant="ghost"
//             color="gray.600"
//             fontWeight="600"
//             onClick={onClose}
//             _hover={{ bg: "gray.100" }}
//           >
//             Cancelar
//           </Button>

//           <Button
//             colorScheme="blue"
//             px={6}
//             fontWeight="600"
//             borderRadius="md"
//             boxShadow="sm"
//             onClick={handleSave}
//             _hover={{
//               transform: "translateY(-1px)",
//               boxShadow: "md"
//             }}
//             _active={{
//               transform: "translateY(0)"
//             }}
//           >
//             <Icon as={FiCalendar} mr={2} />
//             {initialData ? "Salvar alterações" : "Agendar atendimento"}
//           </Button>
//         </ModalFooter>
//       </ModalContent>
//     </Modal>
//   );
// }


import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  VStack,
  HStack,
  Box,
  Text,
  Divider,
  Flex,
  Icon,
  Badge,
  useToast
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import {
  FiCalendar,
  FiClock,
  FiUser,
  FiFileText,
  FiX,
  FiCheckCircle,
  FiXCircle
} from "react-icons/fi";

import PacienteAutocomplete from "../../components/common/PacienteAutocomplete";
import { ProfissionalService } from "../../services/profissional.service";
import { ProcedimentoService } from "../../services/procedimento.service";

type StatusAgendamento = "agendado" | "concluido" | "cancelado";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialData?: any;
  onStatusChange?: (status: "concluido" | "cancelado") => void | Promise<void>;
  statusUpdating?: boolean;
}

function toDatetimeLocal(value?: string) {
  if (!value) return "";

  const normalized = String(value).trim().replace(" ", "T");

  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) {
    return normalized;
  }

  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(normalized)) {
    return normalized.slice(0, 16);
  }

  return normalized;
}

function normalizeStatus(value: unknown): StatusAgendamento {
  if (value === "concluido" || value === "cancelado") {
    return value;
  }

  return "agendado";
}

export default function FormModal({
  isOpen,
  onClose,
  onSave,
  initialData,
  onStatusChange,
  statusUpdating = false
}: Props) {
  const toast = useToast();

  const [profissionais, setProfissionais] = useState<any[]>([]);
  const [procedimentos, setProcedimentos] = useState<any[]>([]);
  const [loadingCombos, setLoadingCombos] = useState(false);

  const [form, setForm] = useState<any>({
    ficha_id: "",
    paciente_label: "",
    profissional_id: "",
    procedimento_id: "",
    data_agendamento: "",
    observacao: ""
  });

  useEffect(() => {
    if (!isOpen) return;

    let active = true;

    async function loadCombos() {
      try {
        setLoadingCombos(true);

        const [p, pr] = await Promise.all([
          ProfissionalService.findAll(),
          ProcedimentoService.findAll()
        ]);

        if (!active) return;

        setProfissionais(Array.isArray(p) ? p : []);
        setProcedimentos(Array.isArray(pr) ? pr : []);
      } catch {
        if (!active) return;

        toast({
          title: "Erro ao carregar profissionais e procedimentos",
          status: "error",
          position: "top-right",
          duration: 3000
        });
      } finally {
        if (active) setLoadingCombos(false);
      }
    }

    loadCombos();

    return () => {
      active = false;
    };
  }, [isOpen, toast]);

  useEffect(() => {
    if (initialData) {
      const endereco = [
        initialData.endereco,
        initialData.numero,
        initialData.bairro,
        initialData.cidade,
        initialData.uf
      ].filter(Boolean).join(", ");

      const pacienteLabel = [
        initialData.paciente_nome,
        initialData.paciente_cpf,
        initialData.titulo,
        endereco
      ].filter(Boolean).join(" - ");

      setForm({
        ficha_id: String(initialData.ficha_id ?? ""),
        paciente_label: pacienteLabel,
        profissional_id: String(initialData.profissional_id ?? ""),
        procedimento_id: String(initialData.procedimento_id ?? ""),
        data_agendamento: toDatetimeLocal(initialData.data_agendamento),
        observacao: initialData.observacao ?? ""
      });

      return;
    }

    setForm({
      ficha_id: "",
      paciente_label: "",
      profissional_id: "",
      procedimento_id: "",
      data_agendamento: "",
      observacao: ""
    });
  }, [initialData, isOpen]);

  function handleSave() {
    if (!form.ficha_id) {
      toast({
        title: "Selecione o paciente",
        status: "error",
        position: "top-right",
        duration: 3000
      });
      return;
    }

    if (!form.profissional_id) {
      toast({
        title: "Selecione o profissional",
        status: "error",
        position: "top-right",
        duration: 3000
      });
      return;
    }

    if (!form.procedimento_id) {
      toast({
        title: "Selecione o procedimento",
        status: "error",
        position: "top-right",
        duration: 3000
      });
      return;
    }

    if (!form.data_agendamento) {
      toast({
        title: "Informe a data do agendamento",
        status: "error",
        position: "top-right",
        duration: 3000
      });
      return;
    }

    onSave({
      ficha_id: Number(form.ficha_id),
      profissional_id: Number(form.profissional_id),
      procedimento_id: Number(form.procedimento_id),
      data_agendamento: form.data_agendamento,
      observacao: form.observacao
    });
  }

  const inputStyles = {
    size: "md" as const,
    borderColor: "gray.200",
    borderRadius: "md",
    bg: "white",
    fontSize: "sm",
    transition: "all 0.2s",
    _hover: {
      borderColor: "gray.300"
    },
    _focus: {
      borderColor: "blue.400",
      boxShadow: "0 0 0 1px var(--chakra-colors-blue-400)"
    }
  };

  const labelStyles = {
    fontSize: "sm",
    fontWeight: "600",
    color: "gray.700",
    mb: 2
  };

  const currentStatus = normalizeStatus(initialData?.status);
  const canChangeStatus = Boolean(
    initialData && currentStatus === "agendado" && onStatusChange
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
      isCentered
      scrollBehavior="inside"
    >
      <ModalOverlay bg="blackAlpha.500" backdropFilter="blur(2px)" />

      <ModalContent
        borderRadius="xl"
        overflow="hidden"
        mx={3}
        boxShadow="0 12px 40px rgba(0, 0, 0, 0.16)"
      >
        <ModalHeader px={6} py={4} borderBottom="1px solid" borderColor="gray.100">
          <Flex align="center" justify="space-between" gap={3}>
            <HStack spacing={3}>
              <Flex
                align="center"
                justify="center"
                boxSize="42px"
                borderRadius="lg"
                bg="blue.50"
                color="blue.600"
                flexShrink={0}
              >
                <Icon as={FiCalendar} boxSize={5} />
              </Flex>

              <Box>
                <Text fontSize="lg" fontWeight="700" color="gray.800" lineHeight="1.4">
                  {initialData ? "Editar agendamento" : "Agendar novo atendimento"}
                </Text>
                <Text fontSize="xs" fontWeight="normal" color="gray.500" mt={1}>
                  Preencha os dados para {initialData ? "atualizar o" : "realizar o"} agendamento
                </Text>
              </Box>
            </HStack>

            <Button
              variant="ghost"
              size="sm"
              minW="32px"
              h="32px"
              px={0}
              color="gray.500"
              aria-label="Fechar modal"
              onClick={onClose}
              _hover={{ bg: "gray.100", color: "gray.700" }}
            >
              <Icon as={FiX} boxSize={5} />
            </Button>
          </Flex>
        </ModalHeader>

        <ModalBody px={{ base: 4, md: 6 }} py={5} bg="gray.50">
          <VStack align="stretch" spacing={5}>
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="lg"
              p={{ base: 3, md: 4 }}
            >
              <HStack spacing={2} mb={4}>
                <Icon as={FiUser} color="blue.500" boxSize={4} />
                <Text fontSize="sm" fontWeight="700" color="gray.700">
                  Dados do paciente
                </Text>
              </HStack>

              <FormControl isRequired>
                <FormLabel {...labelStyles}>Paciente</FormLabel>

                <PacienteAutocomplete
                  valueId={form.ficha_id ? Number(form.ficha_id) : null}
                  valueLabel={form.paciente_label}
                  onSelect={(item) => {
                    if (!item) {
                      setForm((old: any) => ({
                        ...old,
                        ficha_id: "",
                        paciente_label: ""
                      }));
                      return;
                    }

                    const endereco = [
                      item.endereco,
                      item.numero,
                      item.bairro,
                      item.cidade,
                      item.uf
                    ].filter(Boolean).join(", ");

                    const label = [
                      item.nome,
                      item.cpf,
                      item.titulo,
                      endereco
                    ].filter(Boolean).join(" - ");

                    setForm((old: any) => ({
                      ...old,
                      ficha_id: String(item.id),
                      paciente_label: label
                    }));
                  }}
                />

                <Text fontSize="xs" color="gray.500" mt={2}>
                  Pesquise pelo nome ou CPF para localizar o paciente.
                </Text>
              </FormControl>
            </Box>

            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="lg"
              p={{ base: 3, md: 4 }}
            >
              <HStack spacing={2} mb={4}>
                <Icon as={FiFileText} color="blue.500" boxSize={4} />
                <Text fontSize="sm" fontWeight="700" color="gray.700">
                  Dados do atendimento
                </Text>
              </HStack>

              <VStack align="stretch" spacing={4}>
                <FormControl isRequired>
                  <FormLabel {...labelStyles}>Profissional</FormLabel>

                  <Select
                    {...inputStyles}
                    placeholder={loadingCombos ? "Carregando..." : "Selecione o profissional"}
                    value={form.profissional_id}
                    isDisabled={loadingCombos}
                    onChange={(e) =>
                      setForm({ ...form, profissional_id: e.target.value })
                    }
                  >
                    {profissionais.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.nome} - {item.profissao}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl isRequired>
                  <FormLabel {...labelStyles}>Procedimento</FormLabel>

                  <Select
                    {...inputStyles}
                    placeholder={loadingCombos ? "Carregando..." : "Selecione o procedimento"}
                    value={form.procedimento_id}
                    isDisabled={loadingCombos}
                    onChange={(e) =>
                      setForm({ ...form, procedimento_id: e.target.value })
                    }
                  >
                    {procedimentos.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.procedimento}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </VStack>
            </Box>

            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="lg"
              p={{ base: 3, md: 4 }}
            >
              <HStack spacing={2} mb={4}>
                <Icon as={FiClock} color="blue.500" boxSize={4} />
                <Text fontSize="sm" fontWeight="700" color="gray.700">
                  Data e horário
                </Text>
              </HStack>

              <FormControl isRequired>
                <FormLabel {...labelStyles}>Data e hora do agendamento</FormLabel>
                <Input
                  {...inputStyles}
                  type="datetime-local"
                  value={form.data_agendamento}
                  onChange={(e) =>
                    setForm({ ...form, data_agendamento: e.target.value })
                  }
                />
              </FormControl>
            </Box>

            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="lg"
              p={{ base: 3, md: 4 }}
            >
              <FormControl>
                <FormLabel {...labelStyles}>Observações</FormLabel>
                <Textarea
                  {...inputStyles}
                  value={form.observacao}
                  onChange={(e) =>
                    setForm({ ...form, observacao: e.target.value })
                  }
                  placeholder="Adicione informações relevantes sobre o atendimento (opcional)"
                  resize="vertical"
                  minH="90px"
                />
                <Text fontSize="xs" color="gray.500" mt={2}>
                  Campo opcional.
                </Text>
              </FormControl>
            </Box>

            {initialData && (
              <HStack justify="space-between" flexWrap="wrap" spacing={2}>
                <Text fontSize="sm" color="gray.600">
                  Status atual:
                </Text>
                <Badge
                  colorScheme={
                    currentStatus === "concluido"
                      ? "green"
                      : currentStatus === "cancelado"
                        ? "red"
                        : "orange"
                  }
                  px={3}
                  py={1}
                  borderRadius="full"
                >
                  {currentStatus === "concluido"
                    ? "Concluído"
                    : currentStatus === "cancelado"
                      ? "Cancelado"
                      : "Agendado"}
                </Badge>
              </HStack>
            )}
          </VStack>
        </ModalBody>

        <Divider borderColor="gray.100" />

        <ModalFooter
          px={6}
          py={4}
          bg="white"
          justifyContent="space-between"
          gap={3}
          flexWrap="wrap"
        >
          <Button
            variant="ghost"
            color="gray.600"
            fontWeight="600"
            onClick={onClose}
            isDisabled={statusUpdating}
            _hover={{ bg: "gray.100" }}
          >
            Fechar
          </Button>

          <Flex gap={2} flexWrap="wrap" justify="flex-end">
            {canChangeStatus && (
              <>
                <Button
                  leftIcon={<FiCheckCircle />}
                  colorScheme="green"
                  fontWeight="600"
                  onClick={() => onStatusChange?.("concluido")}
                  isLoading={statusUpdating}
                  loadingText="Atualizando"
                >
                  Concluir atendimento
                </Button>

                <Button
                  leftIcon={<FiXCircle />}
                  colorScheme="red"
                  fontWeight="600"
                  onClick={() => {
                    // if (confirm("Deseja realmente cancelar este agendamento?")) {
                      onStatusChange?.("cancelado");
                    // }
                  }}
                  isLoading={statusUpdating}
                  loadingText="Atualizando"
                >
                  Cancelar agendamento
                </Button>
              </>
            )}

            <Button
              colorScheme="blue"
              px={6}
              fontWeight="600"
              borderRadius="md"
              boxShadow="sm"
              onClick={handleSave}
              isDisabled={statusUpdating}
              _hover={{
                transform: "translateY(-1px)",
                boxShadow: "md"
              }}
              _active={{
                transform: "translateY(0)"
              }}
            >
              <Icon as={FiCalendar} mr={2} />
              {initialData ? "Salvar alterações" : "Agendar atendimento"}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
